// Script de gestion des modals produit - Délégation stricte au thème
document.addEventListener('DOMContentLoaded', () => {
    initMMModals();
});

// Scroll lock léger pour la modale Subscription (évite le scroll derrière sur Windows)
let mmSubModalScrollLocked = false;
let mmSubModalPrev = { bodyOverflow: '', bodyTouchAction: '' };

// Variables A11y (Accessibilité)
let mmFocusTrapElement = null;
let mmLastFocusedElement = null;
let mmFocusInHandler = null; // Handler global pour empêcher la fuite

// Variables pour gérer le déplacement de la modale hors du contexte Splide
// On utilise un Map pour gérer plusieurs modales simultanément (au cas où)
const mmModalRestoreData = new Map();

function mmMaterializeCardModal(root) {
    if (!root) return;
    root.querySelectorAll('template.mm-product-card-2-add-to-cart-modal-template').forEach(template => {
        const content = root.ownerDocument === document ? document.importNode(template.content, true) : template.content;
        template.replaceWith(content);
    });
}
window.mmMaterializeCardModal = mmMaterializeCardModal;

function mmTrapFocus(element) {
    if (!element) return;
    
    // Sélecteur des éléments potentiellement focusables
    const focusableSelector = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    
    // Helper pour trouver les éléments VRAIMENT visibles et actifs
    const getVisibleFocusableElements = () => {
        return Array.from(element.querySelectorAll(focusableSelector)).filter(el => {
            return !el.disabled && 
                   !el.hasAttribute('disabled') &&
                   el.offsetParent !== null && 
                   (el.offsetWidth > 0 || el.offsetHeight > 0) &&
                   getComputedStyle(el).visibility !== 'hidden';
        });
    };
    
    // 1. Focus initial
    setTimeout(() => {
        try { 
            const focusable = getVisibleFocusableElements();
            if (focusable.length > 0) focusable[0].focus(); 
        } catch(e) {}
    }, 50);

    mmFocusTrapElement = element;

    // 2. Gestion de la boucle TAB (Confort UX)
    // On garde ça pour que la navigation soit fluide (dernier -> premier)
    if (element._mmKeydownHandler) {
        element.removeEventListener('keydown', element._mmKeydownHandler);
    }

    element._mmKeydownHandler = function(e) {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) return;

        const focusableElements = getVisibleFocusableElements();
        if (focusableElements.length === 0) {
            e.preventDefault();
            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstElement) {
                lastElement.focus();
                e.preventDefault();
            }
        } else { // Tab
            if (document.activeElement === lastElement) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    };
    element.addEventListener('keydown', element._mmKeydownHandler);

    // 3. SECURITÉ GLOBALE (Anti-fuite)
    // Si le focus arrive à sortir (parce que le script keydown a raté un élément), on le ramène.
    if (mmFocusInHandler) {
        document.removeEventListener('focusin', mmFocusInHandler);
    }
    
    mmFocusInHandler = function(e) {
        // Si on a une modale active ET que le focus est sur un élément hors de cette modale
        if (mmFocusTrapElement && !mmFocusTrapElement.contains(e.target)) {
            e.stopPropagation();
            const focusable = getVisibleFocusableElements();
            if (focusable.length > 0) {
                focusable[0].focus();
            } else {
                mmFocusTrapElement.focus();
            }
        }
    };
    document.addEventListener('focusin', mmFocusInHandler);
}

function mmReleaseFocus() {
    // Nettoyage Keydown
    if (mmFocusTrapElement && mmFocusTrapElement._mmKeydownHandler) {
        mmFocusTrapElement.removeEventListener('keydown', mmFocusTrapElement._mmKeydownHandler);
        mmFocusTrapElement._mmKeydownHandler = null;
    }
    
    // Nettoyage FocusIn Global
    if (mmFocusInHandler) {
        document.removeEventListener('focusin', mmFocusInHandler);
        mmFocusInHandler = null;
    }

    if (mmLastFocusedElement) {
        try { mmLastFocusedElement.focus(); } catch(e) {}
        mmLastFocusedElement = null;
    }
    mmFocusTrapElement = null;
}


// Pendant l'ouverture de la modale "subscribe", on désactive le Sticky CTA (classe .active)
// et on le restaure à la fermeture.
const MM_SUBSCRIPTION_MODAL_OPEN_CLASS = 'mm-subscription-modal-open';
const MM_STICKY_CTA_WAS_ACTIVE_ATTR = 'data-mm-sticky-cta-was-active';

function mmSetStickyCtaSuppressed(isSuppressed) {
    try {
        const body = document.body;
        if (!body || !body.classList) return;

        const stickyCTA = document.querySelector('[data-sticky-cta]') || document.querySelector('.mm-product-form-buy-button-infos-sticky-cta');
        if (!stickyCTA || !stickyCTA.classList) {
            // On garde quand même le flag body, pour que mm-main-product.js bloque l'activation si besoin
            body.classList.toggle(MM_SUBSCRIPTION_MODAL_OPEN_CLASS, !!isSuppressed);
            return;
        }

        if (isSuppressed) {
            // Sauvegarder l'état avant suppression (utile car IntersectionObserver peut ne pas recalculer immédiatement)
            if (stickyCTA.classList.contains('active')) {
                body.setAttribute(MM_STICKY_CTA_WAS_ACTIVE_ATTR, '1');
            } else {
                body.setAttribute(MM_STICKY_CTA_WAS_ACTIVE_ATTR, '0');
            }

            body.classList.add(MM_SUBSCRIPTION_MODAL_OPEN_CLASS);
            stickyCTA.classList.remove('active');
        } else {
            const wasActive = body.getAttribute(MM_STICKY_CTA_WAS_ACTIVE_ATTR);
            body.classList.remove(MM_SUBSCRIPTION_MODAL_OPEN_CLASS);

            // Restaurer exactement l'état d'avant l'ouverture
            if (wasActive === '1') stickyCTA.classList.add('active');
            if (wasActive === '0') stickyCTA.classList.remove('active');

            body.removeAttribute(MM_STICKY_CTA_WAS_ACTIVE_ATTR);
        }
    } catch (e) {}
}

/**
 * Init Splide "reassurance" dans la modale subscription.
 * (Le main product l'initialise au chargement, mais la modale est injectée / remplacée dynamiquement)
 */
function mmInitModalReassuranceSplide(root) {
    try {
        if (!root) return;
        const splideElem = root.querySelector?.('.mm-product-form-buy-button-infos-reassurance-splide');

        if (!splideElem) return;

        const slideCount = splideElem.querySelectorAll('.splide__slide').length;
        if (slideCount <= 1) return;

        // IMPORTANT: Détruire toute instance existante avant de réinitialiser
        // pour éviter les conflits et les Splides qui restent visibles
        if (splideElem.splide && typeof splideElem.splide.destroy === 'function') {
            try { 
                splideElem.splide.destroy(); 
                splideElem.splide = null;
            } catch (e) {}
        }

        // Même init que sur la fiche produit (si dispo)
        if (typeof window.initializeSplideReassurance === 'function') {
            window.initializeSplideReassurance(splideElem);

            if (splideElem.splide) {
                return; // OK, on n'a pas besoin du fallback
            }
        }

        // Fallback (si jamais l'asset main product n'est pas chargé OU si l'init a échoué)
        if (typeof Splide !== 'function') return;
        const instance = new Splide(splideElem, {
            type        : 'loop',
            arrows      : false,
            pagination  : true,
            perPage     : 1,
            drag        : 'free',
            snap        : true,
            fixedWidth  : '100%',
            autoplay    : true,
            interval    : 4000,
            pauseOnHover: false,
            breakpoints : { 768: {} },
        }).mount();
        splideElem.splide = instance;
        if (typeof addHorizontalScrollListener === 'function') addHorizontalScrollListener(splideElem, instance);
    } catch (e) {}
}

function mmLockSubModalScroll() {
    if (mmSubModalScrollLocked) return;

    // Si le drawer panier est déjà ouvert, il gère son propre lock.
    const cartOpen = !!document.querySelector('.mm-drawer-cart-wrapper.mm-dc-is-open');
    if (cartOpen) return;

    const body = document.body;
    if (!body) return;

    mmSubModalPrev = {
        bodyOverflow: body.style.overflow || '',
        bodyTouchAction: body.style.touchAction || '',
    };

    body.style.overflow = 'hidden';
    body.style.touchAction = 'none';

    mmSubModalScrollLocked = true;
}

function mmUnlockSubModalScroll() {
    if (!mmSubModalScrollLocked) return;

    // Suppression de la condition qui empêchait le déverrouillage si le panier était ouvert.
    // On doit toujours nettoyer les styles inline ajoutés par la modale.
    // Le panier gérera son propre verrouillage via ses classes (ex: .stop-scrolling sur html).
    
    const body = document.body;
    if (body) {
        body.style.overflow = mmSubModalPrev.bodyOverflow;
        body.style.touchAction = mmSubModalPrev.bodyTouchAction;
    }

    mmSubModalScrollLocked = false;
}

/**
 * Déplace la modale dans le body pour éviter les problèmes de position fixed avec Splide
 * Splide crée un contexte de positionnement qui casse position: fixed
 */
function mmMoveModalToBody(modal, filter) {
    if (!modal) return;
    
    // Sauvegarder les informations de restauration
    const restoreData = {
        modalParent: modal.parentNode,
        modalNextSibling: modal.nextSibling,
        filter: filter || null,
        filterParent: filter ? filter.parentNode : null,
        filterNextSibling: filter ? filter.nextSibling : null,
        wrapper: modal.closest('.mm-product-card-2-add-to-cart')
    };
    
    mmModalRestoreData.set(modal, restoreData);
    
    // Déplacer la modale et le filtre dans le body
    const body = document.body;
    if (body) {
        // S'assurer que la modale est dans son état initial (cachée) avant le déplacement
        modal.style.transform = '';
        modal.style.visibility = '';
        
        body.appendChild(modal);
        
        if (filter && filter.parentNode !== body) {
            body.appendChild(filter);
        }
        
        // Forcer un reflow pour que le navigateur calcule l'état initial
        // avant d'ajouter la classe qui déclenche la transition
        void modal.offsetHeight;
        
        // Utiliser requestAnimationFrame pour s'assurer que la transition se déclenche
        requestAnimationFrame(() => {
            // Ajouter la classe pour indiquer que la modale est ouverte (pour le CSS)
            modal.classList.add('mm-modal-open');
            
            if (filter) {
                filter.classList.add('mm-modal-open');
            }
        });
    }
}

/**
 * Remet la modale à sa place originale
 */
function mmRestoreModalPosition(modal) {
    if (!modal) return;
    
    const restoreData = mmModalRestoreData.get(modal);
    if (!restoreData) {
        // Si pas de données de restauration, juste retirer la classe
        modal.classList.remove('mm-modal-open');
        const filter = document.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-filter.mm-modal-open');
        if (filter) {
            filter.classList.remove('mm-modal-open');
        }
        return;
    }
    
    // Retirer la classe d'ouverture pour déclencher la transition de fermeture
    modal.classList.remove('mm-modal-open');
    
    // Utiliser le filtre sauvegardé ou le chercher
    let filter = restoreData.filter;
    if (!filter && restoreData.wrapper) {
        // Fallback : chercher le filtre dans le wrapper d'origine
        filter = restoreData.wrapper.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-filter');
    }
    // Dernier fallback : chercher dans le body si le filtre y est
    if (!filter) {
        filter = document.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-filter.mm-modal-open');
    }
    
    if (filter) {
        filter.classList.remove('mm-modal-open');
    }
    
    // Attendre la fin de la transition avant de remettre la modale à sa place
    setTimeout(() => {
        // Remettre la modale à sa place originale
        if (restoreData.modalNextSibling && restoreData.modalNextSibling.parentNode === restoreData.modalParent) {
            restoreData.modalParent.insertBefore(modal, restoreData.modalNextSibling);
        } else if (restoreData.modalParent) {
            restoreData.modalParent.appendChild(modal);
        }
        
        // Remettre le filtre aussi si nécessaire
        if (filter && restoreData.filterParent) {
            if (restoreData.filterNextSibling && restoreData.filterNextSibling.parentNode === restoreData.filterParent) {
                restoreData.filterParent.insertBefore(filter, restoreData.filterNextSibling);
            } else {
                restoreData.filterParent.appendChild(filter);
            }
        }
        
        // Nettoyer les données de restauration
        mmModalRestoreData.delete(modal);
    }, 300); // Attendre la durée de la transition (0.3s)
}

function initMMModals() {
    // NOTE : On ne force plus l'initialisation au chargement.
    // On laisse mm_cart.js faire son travail natif sur le HTML existant.
    // On n'intervient que lors des mises à jour dynamiques (variants).

    // Solution simple : fermer la modale quand le drawer panier s'ouvre
    // Le formulaire fonctionne normalement, on ne fait que fermer la modale après l'ajout
    function setupCartDrawerObserver() {
        const cartDrawer = document.querySelector('.mm-drawer-cart-wrapper');
        if (cartDrawer) {
            let lastCartState = cartDrawer.classList.contains('mm-dc-is-open');
            
            const cartObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const isOpen = cartDrawer.classList.contains('mm-dc-is-open');
                        
                        // Si le drawer vient de s'ouvrir, fermer toutes les modales
                        if (isOpen && !lastCartState) {
                            setTimeout(() => {
                                closeAllModals();
                            }, 200);
                        }
                        
                        // Si le drawer vient de se fermer, s'assurer que le scroll est déverrouillé
                        if (!isOpen && lastCartState) {
                            // S'assurer que le scroll est toujours déverrouillé
                            const body = document.body;
                            const html = document.documentElement;
                            if (body && html) {
                                html.classList.remove('stop-scrolling');
                                body.style.position = '';
                                body.style.top = '';
                                body.style.left = '';
                                body.style.right = '';
                                body.style.width = '';
                                body.style.overflow = '';
                                body.style.overscrollBehavior = '';
                                body.style.touchAction = '';
                                if (body.dataset.mmScrollY) {
                                    const storedScrollY = parseInt(body.dataset.mmScrollY || '0', 10);
                                    window.scrollTo(0, storedScrollY);
                                    delete body.dataset.mmScrollY;
                                }
                            }
                        }
                        
                        lastCartState = isOpen;
                    }
                });
            });
            
            cartObserver.observe(cartDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        } else {
            setTimeout(setupCartDrawerObserver, 500);
        }
    }
    setupCartDrawerObserver();

    // Écouteur global avec CAPTURE pour intercepter les interactions UI (Variants, Fermeture)
    document.addEventListener('click', (e) => {
        // Tant que la modale subscription est ouverte, on force le lock du body
        // (le dropdown variants peut remettre overflow à vide sinon)
        if (e.target.closest('.mm-product-card-2-add-to-cart-modal-subscription')) {
            mmLockSubModalScroll();
        }

        // 0. Ouverture modale Subscription -> lock scroll derrière
        const openSubscriptionBtn = e.target.closest('.mm-product-card-2-add-to-cart-cta-modal-subscription');
        if (openSubscriptionBtn) {
            const wrapper = openSubscriptionBtn.closest('.mm-product-card-2-add-to-cart');
            mmMaterializeCardModal(wrapper);

            // A11y: Sauvegarder l'élément qui a déclenché l'ouverture
            mmLastFocusedElement = openSubscriptionBtn;

            // IMPORTANT: on ajoute mm-open ici (au lieu de dépendre d'un <script> inline),
            // comme ça ça marche aussi après remplacement dynamique de la card via fetch/render.
            try {
                closeAllModals();
                if (wrapper) wrapper.classList.add('mm-open');
            } catch(e) {}
            // Désactiver le sticky CTA pendant la modale subscribe
            mmSetStickyCtaSuppressed(true);
            // La classe mm-open est ajoutée par le script inline du snippet, on attend le tick suivant
            setTimeout(() => {
                if (wrapper && wrapper.classList.contains('mm-open')) {
                    mmLockSubModalScroll();
                    const modal = wrapper.querySelector('.mm-product-card-2-add-to-cart-modal-subscription');
                    const filter = wrapper.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-filter');
                    
                    if (modal) {
                        mmMoveModalToBody(modal, filter);
                        
                        // A11y: Activer le Focus Trap
                        mmTrapFocus(modal);
                        
                        mmInitModalReassuranceSplide(modal);
                        // Initialiser le formulaire quand la modale s'ouvre
                        const form = modal.querySelector('form[data-type="add-to-cart-form"]');
                        if (form && typeof window.mmSetupProductFormForSection === 'function') {
                            window.mmSetupProductFormForSection(modal);
                            
                            // FIX: Le formulaire a été cloné pour reset les events, donc les éléments data-drop
                            // ont gardé l'attribut data-dropdown-handled="true" mais ont perdu leurs listeners.
                            // On doit forcer le reset pour que mmInitRechargeUX / handleDropdown les ré-initialise.
                            const newForm = modal.querySelector('form[data-type="add-to-cart-form"]');
                            if (newForm) {
                                newForm.querySelectorAll('[data-drop]').forEach(el => {
                                    delete el.dataset.dropdownHandled;
                                    el.removeAttribute('data-dropdown-handled');
                                });
                            }
                        }
                        // Initialiser l'UX (dropdowns, etc.)
                        mmInitRechargeUX(modal);

                        // Initialiser les dropdowns génériques
                        if (typeof window.handleDropdown === 'function') {
                            window.handleDropdown();
                        }
                    }
                }
            }, 0);
        }

        // 0bis. Ouverture modale Variants (desktop + mobile)
        const openVariantsBtn = e.target.closest('.mm-product-card-2-add-to-cart-cta-modal-variants');
        if (openVariantsBtn) {
            const wrapper = openVariantsBtn.closest('.mm-product-card-2-add-to-cart');
            mmMaterializeCardModal(wrapper);

            // A11y: Sauvegarder le focus
            mmLastFocusedElement = openVariantsBtn;

            try {
                closeAllModals();
                if (wrapper) wrapper.classList.add('mm-open');

                // A11y: Focus Trap pour variants
                const modalVariants = wrapper.querySelector('.mm-product-card-2-add-to-cart-modal-variants');
                if (modalVariants) {
                    mmTrapFocus(modalVariants);
                }

                // Init du slider de réassurance si la modale subscription est présente dans le wrapper
                const subscriptionModal = wrapper.querySelector('.mm-product-card-2-add-to-cart-modal-subscription');
                if (subscriptionModal) {
                    mmInitModalReassuranceSplide(subscriptionModal);
                }

                // Bloquer le scroll en mobile uniquement
                const isMobile = window.innerWidth <= 768 || window.matchMedia('(max-width: 768px)').matches;
                if (isMobile) {
                    // Désactiver aussi le sticky CTA en mobile quand la modale variants est ouverte,
                    // comme pour la modale subscription
                    mmSetStickyCtaSuppressed(true);

                    const body = document.body;
                    if (body) {
                        body.style.overflow = 'hidden';
                        body.style.touchAction = 'none';
                    }
                }
            } catch(e) {}
        }

        // 1. Gestion des Variants (Prioritaire)
        const variantBtn = e.target.closest('.mm-product-variant-card-select');
        if (variantBtn) {
            handleVariantClick(variantBtn, e);
            return;
        }

        // 1bis. Variant selector (mobile) DANS la modale subscription
        // -> on réutilise exactement la même logique de reload que desktop
        const variantSelectorBtn = e.target.closest('.mm-product-variant-selector-item');
        if (variantSelectorBtn && variantSelectorBtn.closest('.mm-product-card-2-add-to-cart-modal-subscription')) {
            handleVariantClick(variantSelectorBtn, e);
            return;
        }

        // 2. Fermeture Modals
        if (e.target.closest('.mm-product-card-2-add-to-cart-modal-subscription-filter')) {
            closeAllModals();
        }

        // 3. Fix Label Radio (Abonnement vs One-time) - Ergonomie
        // On aide juste le clic sur le label à bien cocher le radio si le CSS/HTML pose problème
        const optionLabel = e.target.closest('.mm-product-form-recharge-label');
        if (optionLabel) {
            setTimeout(() => {
                const radioId = optionLabel.getAttribute('for');
                if (radioId) {
                    // IMPORTANT: les ids peuvent être dupliqués si le même produit apparaît plusieurs fois.
                    // On cible d'abord le radio DANS la modale courante, puis fallback global.
                    const modalRoot = optionLabel.closest('.mm-product-card-2-add-to-cart-modal-subscription')
                                  || optionLabel.closest('.mm-product-card-2-add-to-cart');
                    let radio = null;
                    try {
                        const esc = (window.CSS && typeof window.CSS.escape === 'function') ? window.CSS.escape : (s) => s;
                        radio = modalRoot ? modalRoot.querySelector(`#${esc(radioId)}`) : null;
                    } catch (e) {
                        radio = null;
                    }
                    if (!radio) radio = document.getElementById(radioId);
                    if (radio && !radio.checked) {
                        radio.checked = true;
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }, 50);
        }
        
        // NOTE: On NE gère PLUS le clic sur "Add to Cart". 
        // On laisse l'événement bouillonner pour être capté par les listeners de mm_cart.js
        
    }, true); // Capture phase active pour variants et fermeture

    // A11y: Fermeture avec Echap (Escape)
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const openModal = document.querySelector('.mm-product-card-2-add-to-cart.mm-open');
            if (openModal) {
                closeAllModals();
            }
        }
    });

    // Délégation pour le changement d'option (Abonnement/One-time)
    // On garde juste la logique UI (disabled select, prix), le reste est géré par le thème
    document.addEventListener('change', (e) => {
        if (e.target.closest('.mm-product-card-2-add-to-cart-modal-subscription')) {
            if (e.target.name === 'purchase_option') {
                handlePurchaseOptionChange(e.target);
            }
            // FIX: Synchroniser les champs selling_plan (select desktop vs input hidden mobile)
            // Car les deux existent dans le DOM et le dernier (souvent le hidden) écrase l'autre au submit
            if (e.target.name === 'selling_plan') {
                const val = e.target.value;
                const modal = e.target.closest('.mm-product-card-2-add-to-cart-modal-subscription');
                modal.querySelectorAll('[name="selling_plan"]').forEach(input => {
                    if (input !== e.target) {
                        input.value = val;
                    }
                });
            }
        }
    });
}

function mmInitRechargeUX(root) {
    try {
        if (!root) return;

        // Ré-init dropdowns (reassurance) après remplacement dynamique
        if (typeof window.handleDropdown === 'function') {
            window.handleDropdown();
        }

        // Accessibilité clavier : Enter sur les blocs recharge
        const bindEnterToClick = (containerSelector, clickTargetSelector) => {
            const container = root.querySelector(containerSelector);
            if (!container) return;
            if (container.dataset.mmEnterBound === 'true') return;
            container.dataset.mmEnterBound = 'true';

            container.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    const target = container.querySelector(clickTargetSelector);
                    if (target) target.click();
                }
            });
        };

        bindEnterToClick(".mm-product-form-recharge-once", ".mm-product-form-recharge-once-input");
        bindEnterToClick(".mm-product-form-recharge-abonnement", ".mm-product-form-recharge-abonnement-input");
        bindEnterToClick(".mm-product-form-recharge-abonnement-reassurance", '[data-drop="dropdown"]');
    } catch (e) {}
}

// --- FONCTIONS ---

async function handleVariantClick(btn, e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const modal = btn.closest('.mm-product-card-2-add-to-cart-modal-subscription');
    if (!modal) return;

    const variantUrl = btn.dataset.variantUrl;
    if (!variantUrl) return;

    const dropdownWrapper = btn.closest('.mm-variant-dropdown-wrapper');
    if (dropdownWrapper) dropdownWrapper.classList.remove('dropdown-open');

    const container = modal.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-recharge');
    if (container) container.style.opacity = '0.6';

    try {
        const cardView = modal.dataset.cardView || 'card-product-no-delete';
        const fetchUrl = `${variantUrl}${variantUrl.includes('?') ? '&' : '?'}view=${cardView}`;
        const response = await fetch(fetchUrl);
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        mmMaterializeCardModal(doc);

        // Chercher la modale dans le HTML retourné
        const productCard = doc.querySelector('.mm-product-card-2');
        const newModal = productCard?.querySelector('.mm-product-card-2-add-to-cart')?.querySelector('.mm-product-card-2-add-to-cart-modal-subscription')
                   || productCard?.querySelector('.mm-product-card-2-add-to-cart-modal-subscription')
                   || doc.querySelector('.mm-product-card-2-add-to-cart-modal-subscription');
        
        // Chercher le formulaire PARTOUT dans le document pour debug
        const allForms = doc.querySelectorAll('form[data-type="add-to-cart-form"]');
        window.log('info', '🛒 [PRODUCT-MODAL]', `${allForms.length} formulaire(s) trouvé(s) dans le HTML`);

        if (newModal) {
            // VÉRIFIER que le formulaire est dans le HTML récupéré AVANT de remplacer
            const formInNewModal = newModal.querySelector('form[data-type="add-to-cart-form"]');
            const rechargeContainer = newModal.querySelector('.mm-product-card-2-add-to-cart-modal-subscription-recharge');

            window.log('info', '🛒 [PRODUCT-MODAL]', 'Vérification HTML récupéré', { form: !!formInNewModal, recharge: !!rechargeContainer });

            if (!formInNewModal) {
                // Le formulaire n'est pas dans newModal, cherchons-le dans le document complet
                // Il y a 2 formulaires : un dans product-card-2 et un dans la modale
                const allForms = Array.from(doc.querySelectorAll('form[data-type="add-to-cart-form"]'));
                const formInModal = allForms.find(form => {
                    const modalParent = form.closest('.mm-product-card-2-add-to-cart-modal-subscription');
                    return modalParent !== null;
                });

                if (formInModal) {
                    const modalFromDoc = formInModal.closest('.mm-product-card-2-add-to-cart-modal-subscription');
                    if (modalFromDoc) {
                        window.log('info', '🛒 [PRODUCT-MODAL]', 'Utilisation modale complète depuis document');
                        modal.innerHTML = modalFromDoc.innerHTML;
                    } else {
                        window.log('error', '🛒 [PRODUCT-MODAL]', 'Modale parente introuvable');
                        return;
                    }
                } else {
                    window.log('error', '🛒 [PRODUCT-MODAL]', 'Aucun formulaire dans la modale du document');
                    return;
                }
            } else {
                // Le formulaire est dans newModal, on peut l'utiliser normalement
                const variantIdInForm = formInNewModal.querySelector('input[name="id"]')?.value;
                window.log('info', '🛒 [PRODUCT-MODAL]', 'Formulaire trouvé dans HTML récupéré', { variantId: variantIdInForm });

                const oldInnerHTML = modal.innerHTML;
                modal.innerHTML = newModal.innerHTML;
            }

            // Vérifier IMMÉDIATEMENT après le remplacement
            let formImmediate = modal.querySelector('form[data-type="add-to-cart-form"]');
            if (formImmediate) {
                const variantIdImmediate = formImmediate.querySelector('input[name="id"]')?.value;
                window.log('info', '🛒 [PRODUCT-MODAL]', 'Formulaire présent après remplacement', { variantId: variantIdImmediate });
            } else {
                window.log('error', '🛒 [PRODUCT-MODAL]', 'Formulaire disparu après remplacement');
            }

            // Attendre un peu puis initialiser
            setTimeout(() => {
                // Vérifier que le formulaire existe
                let form = modal.querySelector('form[data-type="add-to-cart-form"]');
                if (!form) {
                    window.log('error', '🛒 [PRODUCT-MODAL]', 'Formulaire non trouvé après timeout');
                    return;
                }

                // Vérifier que le formulaire a un variant ID
                const variantId = form.querySelector('input[name="id"]')?.value;
                if (!variantId) {
                    window.log('error', '🛒 [PRODUCT-MODAL]', 'Formulaire sans variant ID');
                    return;
                }

                window.log('info', '🛒 [PRODUCT-MODAL]', 'Formulaire prêt', { variantId });

                // Initialiser le formulaire - C'EST CRITIQUE
                if (typeof window.mmSetupProductFormForSection === 'function') {
                    window.mmSetupProductFormForSection(modal);
                    window.log('info', '🛒 [PRODUCT-MODAL]', 'mmSetupProductFormForSection appelé');

                    // FIX: Le formulaire a été cloné, on doit reset l'état des dropdowns
                    const newForm = modal.querySelector('form[data-type="add-to-cart-form"]');
                    if (newForm) {
                        newForm.querySelectorAll('[data-drop]').forEach(el => {
                            delete el.dataset.dropdownHandled;
                            el.removeAttribute('data-dropdown-handled');
                        });
                    }
                } else if (typeof window.mmSetupProductForm === 'function') {
                    window.mmSetupProductForm();
                    window.log('info', '🛒 [PRODUCT-MODAL]', 'mmSetupProductForm appelé');
                } else {
                    window.log('error', '🛒 [PRODUCT-MODAL]', 'Aucune fonction d\'initialisation disponible');
                }

                // Vérifier après initialisation
                setTimeout(() => {
                    const newForm = modal.querySelector('form[data-type="add-to-cart-form"]');
                    if (newForm) {
                        const newVariantId = newForm.querySelector('input[name="id"]')?.value;
                        window.log('info', '🛒 [PRODUCT-MODAL]', 'Formulaire après init', { variantId: newVariantId });
                    }
                }, 100);
                
                // Réinitialiser l'UI
                const checkedRadio = modal.querySelector('input[name="purchase_option"]:checked');
                if (checkedRadio) {
                    handlePurchaseOptionChange(checkedRadio);
                }
                if (typeof window.applyPurchaseOptionMedia === 'function') {
                    window.applyPurchaseOptionMedia(checkedRadio);
                }
                
                mmInitModalReassuranceSplide(modal);
                mmInitRechargeUX(modal);
                
                // Ne pas réinitialiser mmSetupProductCardVariants ici car cela créerait des doublons
                // Les boutons sont déjà gérés globalement et par section
            }, 150);
        }
    } catch (err) {
        console.error('Erreur chargement variant:', err);
    } finally {
        if (container) container.style.opacity = '1';
    }
}

// Gestion purement UI (visuelle) des champs Abonnement
// Cette partie ne fait pas l'ajout au panier, elle prépare juste le terrain (active/désactive le select)
function handlePurchaseOptionChange(radioInput) {
    const modal = radioInput.closest('.mm-product-card-2-add-to-cart-modal-subscription');
    if (!modal) return;

    // MODIFICATION: On cible TOUS les champs selling_plan (select et hidden input)
    // car il peut y avoir un input hidden pour le mobile qui doit aussi être désactivé
    const sellingPlanInputs = modal.querySelectorAll('[name="selling_plan"]');
    const form = modal.querySelector('form');
    const isAbonnement = (radioInput.value === 'abonnement');
    
    // UI: Activer/Désactiver le(s) champ(s) de fréquence
    if (sellingPlanInputs.length > 0) {
        sellingPlanInputs.forEach(input => {
            if (isAbonnement) {
                input.disabled = false;
                input.removeAttribute('disabled');
                
                // Si c'est un select et qu'il n'a pas de valeur, on prend la première
                if (input.tagName === 'SELECT' && !input.value && input.options && input.options.length > 0) {
                    input.value = input.options[0].value;
                }
            } else {
                input.disabled = true;
                input.setAttribute('disabled', 'disabled');
            }
        });
    }

    // UI: Mise à jour du champ hidden properties[_recharge]
    // Note: mm_cart.js gère aussi ses propres propriétés, mais ceci aide pour l'affichage conditionnel panier
    if (form) {
        let rechargeInput = form.querySelector('input[name="properties[_recharge]"]');
        if (!rechargeInput) {
            rechargeInput = document.createElement('input');
            rechargeInput.type = 'hidden';
            rechargeInput.name = 'properties[_recharge]';
            form.appendChild(rechargeInput);
        }
        /**
         * IMPORTANT (cohérence avec le formulaire produit):
         * On conserve toujours properties[_recharge]="oui" (même en achat unique).
         * Le panier (`mm-cart-item.liquid`) utilise cette propriété pour afficher la ligne
         * "Subscribe and save …" (checkbox décochée si pas de selling_plan).
         *
         * La vraie différence abonnement vs achat unique reste portée par `selling_plan` :
         * - abonnement: selling_plan envoyé (select activé)
         * - achat unique: selling_plan NON envoyé (select désactivé)
         */
        rechargeInput.value = 'oui';
        rechargeInput.disabled = false;
    }
    
    // UI: Mise à jour des prix affichés sur le bouton
    updateButtonPrice(modal);
}

function updateButtonPrice(modal) {
    const isAbonnement = modal.querySelector('input[name="purchase_option"][value="abonnement"]')?.checked;
    const btnPriceContainer = modal.querySelector('.mm-buy-button-prices');
    if (!btnPriceContainer) return;
    
    const targetClass = isAbonnement ? '.mm-product-form-recharge-abonnement' : '.mm-product-form-recharge-once';
    const sourceContainer = modal.querySelector(targetClass);
    
    if (sourceContainer) {
        const sourcePrice = sourceContainer.querySelector('.mm-product-price');
        const sourceCompare = sourceContainer.querySelector('.mm-product-compare-at-price');
        
        if (sourcePrice) {
            const destPrice = btnPriceContainer.querySelector('.mm-product-price');
            if (destPrice) destPrice.innerHTML = sourcePrice.innerHTML;
        }
        
        const destCompare = btnPriceContainer.querySelector('.mm-product-compare-at-price');
        if (destCompare) {
            if (sourceCompare) {
                destCompare.innerHTML = sourceCompare.innerHTML;
                destCompare.hidden = false;
            } else {
                destCompare.hidden = true;
            }
        }
    }
}

function closeAllModals() {
    // FIX: Remettre les modales à leur place originale avant de fermer
    const openModals = document.querySelectorAll('.mm-product-card-2-add-to-cart-modal-subscription');
    openModals.forEach(modal => {
        // Détruire le Splide de réassurance avant de fermer la modale
        const splideElem = modal.querySelector?.('.mm-product-form-buy-button-infos-reassurance-splide');
        if (splideElem && splideElem.splide && typeof splideElem.splide.destroy === 'function') {
            try {
                splideElem.splide.destroy();
                splideElem.splide = null;
            } catch (e) {}
        }
        
        mmRestoreModalPosition(modal);
    });
    
    document.querySelectorAll('.mm-product-card-2-add-to-cart.mm-open').forEach(el => {
        el.classList.remove('mm-open');
    });
    
    // A11y: Relâcher le focus et le rendre au bouton déclencheur
    mmReleaseFocus();

    mmUnlockSubModalScroll();
    
    // Déverrouiller le scroll en mobile (pour la modale variants)
    const isMobile = window.innerWidth <= 768 || window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
        const body = document.body;
        if (body) {
            body.style.overflow = '';
            body.style.touchAction = '';
        }
    }
    
    // Réactiver le sticky CTA (si on était en mode "modale subscribe ouverte")
    mmSetStickyCtaSuppressed(false);
}
